module.exports = require('./lib/node_cache');


//////////////////
// WEBPACK FOOTER
// ./~/node-cache/index.js
// module id = 4023
// module chunks = 62